import React, { useEffect, useState } from "react";
import "components/Layout/style.css";
import Grid from "@mui/material/Grid";
import { useStore } from "_Store";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import translation from "assets/mock/frenchTranslation.json";
import Loading from "components/Ui/Loading"

const CahierResume = (props) => {
  const { state } = useStore();
  const [commodities, setCommodities] = useState([]);
  const [seedDatas, setSeedData] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [submitted, setIsSubmitted] = useState(false);
  const formatter = new Intl.DateTimeFormat("fr", { month: "long", day: 'numeric', year: 'numeric'});
  //const commodities= state.userProfile?.commodities
  const data = state.cahierTableDataResponse;

  const columns = [
    { key: "Champs", value: "farmId" },
    { key: "Culture", value: "seed" },
    { key: "Date", value: "date" },
    { key: "Trésorerie", value: "typeData" },
  ];

  useEffect(() => {
    getSeedData();
  }, []);

  useEffect(() => {
    setCommodities(seedDatas)
  }, [seedDatas]);

  const handleSubmit = async () => {
    setLoading(true)
    setIsSubmitted(true)
    state.cahierData.push(state.cahierTableDataResponse);
      props.onSubmit(state.cahierTableDataResponse, true);
  };

  function getSeedData(){

    let products = state.activeCampaign.productsYouGrow,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let seed = product.seed;
         data=[...data,{id: seed.id,name: seed.seedName}];
       }
     }
     setSeedData(data)
   }

  const filterData = (key, value) => {
    if (key === "farmId") {
      return state.activeFarm.farmName
    }else if (key === "seed") {
      const filter = commodities?.find((res)=>res.id === value)
      return filter?.name;
    }else if( key === "paymentMadeIn"){
     const filter= state.paymentOption.filter((option)=> option?.id === value)
     return filter[0]?.type
    }else{
      const filter= state.entriesAndExitsOptionsList.filter((option)=> option?.id === value)
      return filter[0]?.type
    }
  };

  return (
    <div>
      {loading ? <Loading/> : null }
      <Grid className="stepFormfields">
        <WelcomeLayout
          content={"Journal de caisse"}
          handleSubmit={handleSubmit}
          buttonLabel={"Soumettre"}
          showInfo={false}
          isSubmit={false}
          task={"Veillez à consulter le resumé de votre opération avant d'enrégistrer car vous ne pouvez pas supprimer une opération sauvegarder; à moins de faire une opération contraire."}
          buttonDisabled={submitted}
          backToStartBtn={{ 
            label:'précédent',
            onClick: () => {
              props.onBack();
            } 
          }}
        >
          <div className="ResumeTableSection">
            <div className="fremimg">
              <h3 style={{ textAlign: "left" }}>Résumé</h3>
            </div>
            <table style={{ width: "100%" }} className="resumeTabels">
              {columns?.map((col) => (
                <tr>
                  <th>{col.key}</th>
                  {typeof data[col.value] === "object" ? (
                    col?.value === "date" ? (
                      <td>{`${formatter.format(
                        new Date(data[col?.value])
                      )}`}</td>
                    ) : (
                      <td>
                        <h1>{translation[data.cashTransaction]}</h1>
                        {Object.keys(data[col.value])?.map((ref) => {
                          return (
                            <div>
                              <h4>{translation[ref]}</h4>
                              {typeof data[col.value][ref] === "string" ? (
                                <p>{data[col.value][ref]} {ref && ref.toLowerCase()==="cost" ? "CFA" : ""}</p>
                              ) : (
                                <p>
                                  {filterData(ref, data[col.value][ref])}
                                </p>
                              )}
                            </div>
                          );
                        })}
                      </td>
                    )
                  ) : (
                    <td>{filterData(col.value, data[col?.value])}</td>
                  )}
                </tr>
              ))}
            </table>
          </div>
        </WelcomeLayout>
      </Grid>
    </div>
  );
};

export default CahierResume;
